import checkItem from '../Checkbox/CheckItem';
export default checkItem('switch');